import React, { useState } from 'react';
import { cn } from 'lib/utils';
import { Input } from 'components/ui/input';
import { Button } from 'components/ui/button';

/** Generic: calls `onSubmit(code)` with the trimmed string; the consumer auto-detects the code kind. */
export interface CodeEntryProps {
  onSubmit: (code: string) => void;
  submitLabel: string;
  placeholder?: string;
  loading?: boolean;
  className?: string;
}

export function CodeEntry({ onSubmit, submitLabel, placeholder, loading, className }: CodeEntryProps) {
  const [code, setCode] = useState('');
  const trimmed = code.trim();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (trimmed) onSubmit(trimmed);
  };

  return (
    <form onSubmit={handleSubmit} className={cn('flex items-center gap-2', className)}>
      <Input
        value={code}
        onChange={(e) => setCode(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        autoComplete="off"
        spellCheck={false}
        className="min-w-0 flex-1 font-mono uppercase tracking-wider placeholder:font-sans placeholder:text-sm placeholder:normal-case placeholder:tracking-normal"
      />
      <Button type="submit" disabled={loading || !trimmed}>
        {submitLabel}
      </Button>
    </form>
  );
}

export default CodeEntry;
